module.exports={
  "location": "Location",
  "findFacility": "Find a facility",
  "hotelSearchPlaceholder": "Enter a hotel name or address",
  "organizationSearchPlaceholder": "Enter an organization name or address",
  "findFacilitySearchPlaceholder": "Enter a facility name or address",
  "findByCriteria": "Find new opportunities",
  "findByCriteriaDescriptionSs": "I am looking for facilities {chunk} of the following criteria",
  "addCriterion": "Add criterion",
  "loadingFacilities": "Loading facilities...",
  "findFacilities": "Apply filter"
}
